import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ArtPopoverPage } from './art-popover.page';

const routes: Routes = [
  {
    path: '',
    component: ArtPopoverPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ArtPopoverPageRoutingModule {}
